import { render, staticRenderFns } from "./TicketListPage.vue?vue&type=template&id=3d7d4ea2&"
import script from "./TicketListPage.vue?vue&type=script&lang=ts&"
export * from "./TicketListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports